module.exports = __webpack_public_path__ + "static/media/flash2.ab31ea27.svg";